<script lang="ts">
  // Ein Kontingent klein: Symbol (Uhr = 5-Stunden-Fenster, Kalender =
  // Woche, Sonne = eigenes Tageslimit) und Füllbalken in der Farbe nach
  // verbrauchTon; aufgebraucht statt des vollen Balkens die Uhrzeit, wann
  // es wieder voll ist (Tim 19.10.2026). Für zugeklappte Abschnitte im Baum
  // (BaumZu) und den schmalen Chat-Kopf -- überall dieselben Zeichen für
  // dasselbe. Ein Modell-Fenster (Fable) hat kein Symbol: dann sein Name.
  import Icon from "../Icon.svelte";
  import { prozent, uhrBis, verbrauchTon, type Fenster } from "./claude";

  interface Props {
    f: Fenster;
    icon?: "clock" | "calendar" | "sun";
    /** statt des Symbols ein Name („Fable") */
    name?: string;
    jetzt: Date;
    /** die Prozentzahl hinter dem Balken */
    zahl?: boolean;
  }
  let { f, icon, name, jetzt, zahl = false }: Props = $props();

  const ton = $derived(verbrauchTon(f.anteil));
  const zeit = $derived(uhrBis(f.bis, jetzt));
</script>

{#if (f.anteil ?? 0) >= 1 && zeit}
  <span class="teil text-danger">{@render zeichen()}{zeit}</span>
{:else}
  <span class="teil {ton === 'danger' ? 'text-danger' : ton === 'warn' ? 'text-warning' : ''}">
    {@render zeichen()}
    <span class="balken"><i class={ton} style:width="{Math.min(100, Math.round((f.anteil ?? 0) * 100))}%"></i></span>
    {#if zahl}<span class="prozent">{prozent(f.anteil)}</span>{/if}
  </span>
{/if}

{#snippet zeichen()}
  {#if icon}<Icon name={icon} size={12} />{:else if name}<span class="name">{name}</span>{/if}
{/snippet}

<style>
  .teil {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex: none;
    height: 1.15rem;
  }
  .balken {
    width: 2rem;
    height: 5px;
    border-radius: 3px;
    background: color-mix(in oklab, var(--fg) 12%, transparent);
    overflow: hidden;
    display: inline-block;
  }
  .balken i {
    display: block;
    height: 100%;
    background: var(--fg-muted);
  }
  .balken i.warn {
    background: var(--warning);
  }
  .balken i.danger {
    background: var(--danger);
  }
  /* Schmaler Baum: nur die Balken -- die Zahl schnitte den Kopf an. */
  @container baum (max-width: 240px) {
    .prozent {
      display: none;
    }
  }
</style>
